import { connect } from 'react-redux';
import { State } from 'store/types';
import View from './View';


const mapStateToProps = (state: State) => {
  const { remoteConfig } = state;
  return {
    appLinkEnabled: remoteConfig?.switches.appLinkEnabled,
    appLinks: remoteConfig?.configs.appLinks,
  };
};

export default connect(mapStateToProps)(View);
